// extracted by mini-css-extract-plugin
export default {"mapMarkerNumber":"Customers_mapMarkerNumber__mePW0"};